export const initialValues = {
  search: "",
  selectedIds: [],
  selectedEmails: [],
};
